<div class="block-header">
    <h2> <i *ngIf="icon" [class]="icon + ' mr-2'"></i>  {{ title }} </h2>
    <small class="text-muted"> {{ subtitle }} </small>
</div>